import { useState } from 'react'
import { Button } from '@vale/agata-components-react'
import { Drawer, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { appInsights } from '../../config/appInsights'
import { Eventos } from 'utils/appInsightsConstants'
import { v4 as uuidv4 } from 'uuid'
import { useDispatch, useSelector } from 'react-redux'
import {
  CloseIcon,
  Content,
  Container,
  DividerFixed,
  HelpOutlineIcon,
  FooterMenu,
  IconButton,
  HeaderMenu,
  Titulo
} from './MenuAjuda.styles'
import { menuAjudaState, setClose } from '../../store/slices/menuAjudaSlice'
import { IMenuAjudaState } from '../../store/slices/types'

export function MenuAjuda() {
  const [telemetryCorrelationId] = useState(uuidv4())
  const dispatch = useDispatch()
  const menuAjuda: IMenuAjudaState = useSelector(menuAjudaState)
  const [desabilitaBotao, setDesabilitaBotao] = useState('')
  const btnUtilidadeSim = 'btn-utilidade-sim'
  const btnUtilidadeNao = 'btn-utilidade-nao'
  const { t } = useTranslation('translation', {
    keyPrefix: 'menu_ajuda'
  })

  const handleClose = () => {
    setDesabilitaBotao('')
    dispatch(setClose())
  }

  const trackEventMensagemUtil = (mensagemUtil: boolean) => {
    if (desabilitaBotao === '') {
      if (mensagemUtil) {
        setDesabilitaBotao(btnUtilidadeNao)
      } else {
        setDesabilitaBotao(btnUtilidadeSim)
      }

      appInsights.trackEvent({
        name: Eventos.MENU_AJUDA,
        properties: {
          'vale-correlation-id': telemetryCorrelationId,
          'mensagem-util': mensagemUtil,
          'titulo-mensagem': menuAjuda.nomeTrackEvent
        }
      })
    }
  }

  return (
    <Drawer
      anchor="right"
      open={menuAjuda.open}
      onClose={handleClose}
      data-testid="menu-ajuda"
    >
      <Container>
        <HeaderMenu>
          <div>
            <HelpOutlineIcon />
            <Typography variant="h6">{t('titulo')}</Typography>
          </div>
          <IconButton onClick={handleClose} data-testid="btn-close">
            <CloseIcon />
          </IconButton>
        </HeaderMenu>
        <DividerFixed orientation="horizontal" />
        <Titulo variant="h5">{menuAjuda.titulo}</Titulo>
        <Content>{menuAjuda.children}</Content>
        <FooterMenu>
          <Typography variant="body2" data-testid="texto-utilidade">
            {t('utilidade.mensagem')}
          </Typography>
          <Box>
            <Button
              color="main"
              size="small"
              variant="contained"
              data-testid="btn-utilidade-sim"
              onClick={() => trackEventMensagemUtil(true)}
              disabled={desabilitaBotao === btnUtilidadeSim}
              style={{ marginRight: '16px' }}
            >
              {t('utilidade.sim')}
            </Button>
            <Button
              color="main"
              size="small"
              variant="contained"
              data-testid="btn-utilidade-nao"
              onClick={() => trackEventMensagemUtil(false)}
              disabled={desabilitaBotao === btnUtilidadeNao}
            >
              {t('utilidade.nao')}
            </Button>
          </Box>
        </FooterMenu>
      </Container>
    </Drawer>
  )
}
